export default {
  CREATE_PAYMENTSCHEDULES (state, item) {
    state.paymentschedules.unshift(item)
  },
 
  SET_PAYMENTSCHEDULES (state, paymentschedules) {
    state.paymentschedules = paymentschedules
  },

  UPDATE_PAYMENTSCHEDULES (state, paymentschedule) {
    const paymentscheduleIndex = state.paymentschedules.findIndex((p) => p.id === paymentschedule.id)
    Object.assign(state.paymentschedules[paymentscheduleIndex], paymentschedule)
  }
}
